import React from 'react'
import cn from 'classnames'
import { v1 as uuidv1 } from 'uuid'
import { Field } from 'redux-form/immutable'

import CountryCodeSelect from 'app/components/Input/CountryCodeSelect'
import ErrorLabel from 'app/components/ErrorLabel/ErrorLabel'
import ErrorBlock from 'app/components/ErrorBlock'
import Zoom from 'app/components/SVGS/Zoom'

import './styles.scss'

const bc = 'input-component'

const Input = ({
  placeholder = '',
  id,
  label = '',
  className,
  classNamePhoneComponentWrapper,
  classNamePhoneComponentItem,
  inputClass,
  labelClass,
  disabled,
  input,
  meta: { error, touched } = {},
  name,
  type = 'text',
  autoFocus,
  errorBlock = false,
  isRow = false,
  prefixForField,
  skipMargin,
  onKeyPress,
  errorLabel,
  createErrorLabelStyles,
  checkIsErrorTypeAllowed = () => false,
}) => {
  const inputId = id || uuidv1()
  const isPhoneComponent = type === 'tel'
  return (
    <div
      className={cn(
        bc,
        {
          [`${bc}__row`]: isRow,
          [`${bc}__skip-margin`]: skipMargin,
        },
        className
      )}
    >
      <div
        className={cn({
          [`${bc}__label-hidden`]: !label,
        })}
      >
        <label
          className={cn(
            `${bc}__label`,
            {
              [`${bc}__label-row`]: isRow,
            },
            labelClass
          )}
          htmlFor={inputId}
        >
          {label}
        </label>
      </div>
      <div className={`${bc}__wrapper-column`}>
        <div
          className={cn(`${bc}__wrapper`, {
            [`${bc}__wrapper--phone`]: isPhoneComponent,
            [classNamePhoneComponentWrapper]: classNamePhoneComponentWrapper,
          })}
        >
          {isPhoneComponent && (
            <Field
              name={`${prefixForField}phoneISO`}
              component={CountryCodeSelect}
              prefixForField={prefixForField}
              classNamePhoneComponentItem={classNamePhoneComponentItem}
            />
          )}
          <input
            id={inputId}
            className={cn(
              `${bc}__field`,
              {
                [`${bc}__field--error`]: touched && error,
                [`${bc}__field--search`]: type === 'search',
                [`${bc}__field--phone`]: isPhoneComponent,
                [`${bc}__field--row-error`]: touched && error && isRow,
                [`${bc}__field--allowed-error-type`]: checkIsErrorTypeAllowed(error)
              },
              inputClass
            )}
            type={type}
            placeholder={placeholder}
            disabled={disabled}
            name={name}
            autoFocus={autoFocus}
            onKeyPress={onKeyPress}
            {...input}
          />
          {type === 'search' && (
            <div className={`${bc}__zoom`}>
              <Zoom />
            </div>
          )}
        </div>

        {touched &&
          error &&
          (errorBlock ? (
            <ErrorBlock>{error}</ErrorBlock>
          ) : (
            <ErrorLabel
              createErrorLabelStyles={createErrorLabelStyles}
              before={errorLabel || label}
              htmlFor={inputId}
              error={error}
              style={{ marginTop: '8px' }}
            />
          ))}
      </div>
    </div>
  )
}

Input.defaultProps = {
  prefixForField: '',
}

export default Input
